/* TRIO – Cocon */
(function () {
  'use strict';
  if (window.__trioCocon) return;
  window.__trioCocon = true;

  function feat(root) {
    root.querySelectorAll('[data-tc-feat]').forEach(function (sec) {
      var pts = sec.querySelectorAll('.tc-pt');
      var items = sec.querySelectorAll('.tc-feat li');
      function set(i) {
        pts.forEach(function (p, k) { p.setAttribute('aria-pressed', k === i ? 'true' : 'false'); });
        items.forEach(function (it, k) { it.classList.toggle('is-active', k === i); it.querySelector('button').setAttribute('aria-expanded', k === i ? 'true' : 'false'); });
      }
      pts.forEach(function (p, k) { p.addEventListener('click', function () { set(k); }); });
      items.forEach(function (it, k) { it.querySelector('button').addEventListener('click', function () { set(k); }); });
      set(0);
    });
  }

  function colors(root) {
    root.querySelectorAll('[data-tc-col]').forEach(function (sec) {
      var btns = sec.querySelectorAll('.tc-sw__btn');
      var imgs = sec.querySelectorAll('.tc-col__img');
      var arch = sec.querySelector('.tc-col__art .tc-arch');
      var name = sec.querySelector('.tc-col__name');
      var cta = sec.querySelector('[data-tc-col-cta]');
      btns.forEach(function (b, k) {
        b.addEventListener('click', function () {
          btns.forEach(function (x, j) { x.setAttribute('aria-pressed', j === k ? 'true' : 'false'); });
          imgs.forEach(function (m, j) { m.classList.toggle('is-active', j === k); });
          if (arch && b.dataset.tint) arch.style.background = b.dataset.tint;
          if (name) name.textContent = b.dataset.name;
          if (cta && b.dataset.link) cta.href = b.dataset.link;
        });
      });
    });
  }

  function header() {
    var h = document.querySelector('.tr-header');
    if (!h) return;
    var on = function () { h.style.borderBottomColor = window.scrollY > 8 ? 'var(--tc-line)' : 'transparent'; };
    window.addEventListener('scroll', on, { passive: true }); on();
  }

  function init(root) { root = root || document; feat(root); colors(root); }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', function () { init(); header(); }); else { init(); header(); }
  document.addEventListener('shopify:section:load', function (e) { init(e.target); });
})();
